// client/src/locales/en

const en = {
  translation: {
    publication: {
      subjects: "All subjects", 
      sort: "Sort", 
      date_newest: "Sort on date (Newest)", 
      date_oldest: "Sort on date (Oldest)", 
      title_a_z: "Sort on title (A-Z)", 
      title_z_a: "Sort on title (Z-A)" ,
      nadaa: "Belum ada acara yang direncanakan.",
      search_placeholder: "Search on title or author",
      date_from: "From",
      date_to: "To",
      search_button: "Show results",
      no_results: "No publication found."
    },
    shop: {
      order: "Pesanan Anda", 
      place_order: "Permintaan Bahan", 
      filter: "Semua topik", 
      download: "Unduh", 
      prev: "Langkah sebelumnya",
      form: "Data alamat", 
      max: "Anda mencapai batas maksimum yang diperbolehkan untuk memesan",
      aside_title: "pesanan Anda" , 
      selected_items: "Produk yang dipilih", 
      thanks: "Terima kasih",
      form_submit: 'Menyerahkan formulir',
    },
    form: {
      form_submit: 'Menyerahkan formulir',
      make_a_choice: 'Pilih sebuah opsi ',
    },
    general: {
      readMore: 'Read more',
      loading: 'Loading',
      close: 'Close',
      disclaimer: 'Hanya untuk tenaga kesehatan profesional', 
    },
    blocks: {
      imageContainer: {
        error: 'Error loading image'
      },
      mapBlock: {
        visitWebsite: 'Visit website',
        map: 'Map',
        list: 'List',
      },
    },
    searchbar: {
      label: 'Apa yang sedang Anda cari?',
      placeholder: 'Contoh: Harga susu',
    },
    regionSwitch: {
      title: "FrieslandCampina, your global dairy partner",
      description: "We are a worldwide dairy cooperation, operating in more than 50 countries",
      language: "Global"
    },
    footer: {
      links: {
        privacy: 'Privacy',
        terms_conditions: 'Terms & Conditions',
      },
      follow_us: 'Follow us',
    },
    404: {
      title: "Sorry, we can't find the page you're looking for",
      description:
        "It seems like the page doesn't exist (anymore) or perhaps is moved. Ofcourse you can always go back to our homepage.",
      link: '/',
      homepage: 'To homepage',
    },
    cookiebar: {
      title: 'Welcome!',
      description:
        "Probably you're already familiair with companies who are settings cookies on your desktop, tablet or phone. Friesland Campina is also using cookies and you can choose which ones.",
      accept: 'Accept',
      complete: {
        title: 'Complete cookies',
        description:
          "Met behulp van deze cookies verbeteren we de website, maken we een koppeling met social media, kunt u video's bekijken en een adviseur zoeken.",
      },
      limited: {
        title: 'Beperkte cookies',
        description:
          "Met deze cookies kunt u een adviseur zoeken, video's bekijken en kunnen wij de website verbeteren.",
      },
      functional: {
        title: 'Functionele cookies',
        description:
          "Deze cookies zijn noodzakelijk voor het functioneren van de website. U kunt geen video's bekijken en geen adviseur zoeken.",
      },
      decline: 'No, decline',
      statement: 'Cookie statement',
      missing: 'You need to enable our cookies to view this video.',
      settings: "Pengaturan cookie"
    },
    searchResults: {
      title: 'Anda mencari',
      noSearchTerm: 'Anda belum memasukkan istilah carian',
      types: {
        article: "Article",
        page: 'Page',
        news: 'News',
        story: 'Story',
        webinar: "Webinar",
        conference: "Conference",
        events: "Event", 
      },
      noResults: 'Tiada hasil ditemui, cuba lagi dengan petua berikut:',
      noResultsTips: {
        spelling: 'Semak ejaan anda',
        describe: 'Terangkan carian anda secara berbeza',
        shorter: 'Pendekkan carian anda',
      },
    },
    filter: {
      noResults: 'There are no results found when filtering on this category. Please select a different category or click <a href="/frieslandcampina-news/">here</a> to go to the news overview.'
    },
    pagination: {
      previous: 'Previous',
      next: 'Next',
    },
    show_button: {
      more: 'Show more',
      less: 'Show less'
    },
    share_link: {
      title: 'Share on'
    },
    news: {
      categories: 'Categories:',
    },
    story: {
      categories: 'Categories:',
    },
    filters: {
      filter_on: 'Filter on:',
      category: 'Category',
      all_categories: 'All categories',
      year: 'Year',
      all_years: 'All years',
    },
    formMessage: 'Checking...',
    highlights: {
      title: 'Today at FrieslandCampina',
      footer_copy: 'Find out what else is going on at FrieslandCampina:',
      link_copy: 'Visit our newsroom',
      link_url: "/frieslandcampina-news/"
    },
    certificate:{
      download: "Unduh sertifikat",
      find_download: "Anda akan menemukan sertifikat di folder unduhan"
    }
  },
}

export default en;
